import useUserAchievements from "../routes/achievements/hooks/useUserAchievements";
import clsx from "clsx";
import AchievementTooltip from "./AchievementTooltip";
import { useShowUserAchievements } from "../hooks/useShowUserAchievements";
import Achievements from "./Achievements/Achievements";
import PlaceholderAchievements from "./Achievements/PlaceHolderAchievements";

type Props = { swooshHandle: string; showUserSettings?: boolean };

const ActionsMenu: React.FC<Props> = ({ swooshHandle }) => {
  const { data } = useUserAchievements(swooshHandle);

  const { showUserAchievements, showPlaceholderAchievements } =
    useShowUserAchievements(data, swooshHandle);

  const showAchievementsTooltip =
    showUserAchievements || showPlaceholderAchievements;
  return (
    <div
      className={clsx(
        "dark -mt-px -mr-px flex",
        "flex-col gap-5 justify-end",
        "mt-9",
      )}
    >
      {showAchievementsTooltip && <AchievementTooltip />}
      {showUserAchievements && (
        <Achievements userAchievements={data} swooshHandle={swooshHandle} />
      )}
      {showPlaceholderAchievements && <PlaceholderAchievements />}
    </div>
  );
};

export default ActionsMenu;
